<template>
  <div ref="el" class="chart-box" :style="{ height }" />
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from "vue";
import * as echarts from "echarts/core";
import { BarChart, LineChart, PieChart, GaugeChart } from "echarts/charts";
import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
  TitleComponent,
  DataZoomComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GaugeChart,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  TitleComponent,
  DataZoomComponent,
  CanvasRenderer,
]);

const props = defineProps({
  option: { type: Object, default: null },
  height: { type: String, default: "180px" },
});

const el = ref(null);
let chart = null;
let ro = null;

function render() {
  if (!chart || !props.option) return;
  chart.setOption(props.option, { notMerge: true });
}

onMounted(() => {
  if (!el.value) return;
  chart = echarts.init(el.value, null, { renderer: "canvas" });
  render();
  ro = new ResizeObserver(() => chart?.resize());
  ro.observe(el.value);
});

watch(() => props.option, render, { deep: true });

onUnmounted(() => {
  ro?.disconnect();
  chart?.dispose();
  chart = null;
});
</script>

<style scoped>
.chart-box {
  width: 100%;
  min-height: 120px;
}
</style>
